// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host ::ng-deep {
  /* Functional styling;
   * These styles are required for noUiSlider to function.
   * You don't need to change these rules to apply your design.
   */
  /* Wrapper for all connect elements.
   */
  /* Offset direction
   */
  /* Give origins 0 height/width so they don't interfere with clicking the
   * connect elements.
   */
  /* Slider size and handle placement;
   */
  /* Styling;
   * Giving the connect element a border radius causes issues with using transform: scale
   */
  /* Handles and cursors;
   */
  /* Handle stripes;
   */
  /* Disabled state;
   */
  /* Base;
   *
   */
  /* Values;
   *
   */
  /* Markings;
   *
   */
  /* Horizontal layout;
   *
   */
  /* Vertical layout;
   *
   */
}
:host ::ng-deep .noUi-target,
:host ::ng-deep .noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}
:host ::ng-deep .noUi-target {
  position: relative;
}
:host ::ng-deep .noUi-base,
:host ::ng-deep .noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}
:host ::ng-deep .noUi-connects {
  overflow: hidden;
  z-index: 0;
}
:host ::ng-deep .noUi-connect,
:host ::ng-deep .noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}
:host ::ng-deep .noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}
:host ::ng-deep .noUi-vertical .noUi-origin {
  top: -100%;
  width: 0;
}
:host ::ng-deep .noUi-horizontal .noUi-origin {
  height: 0;
}
:host ::ng-deep .noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}
:host ::ng-deep .noUi-touch-area {
  height: 100%;
  width: 100%;
}
:host ::ng-deep .noUi-state-tap .noUi-connect,
:host ::ng-deep .noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}
:host ::ng-deep .noUi-state-drag * {
  cursor: inherit !important;
}
:host ::ng-deep .noUi-horizontal {
  height: 18px;
}
:host ::ng-deep .noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  right: -17px;
  top: -6px;
}
:host ::ng-deep .noUi-vertical {
  width: 18px;
}
:host ::ng-deep .noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  right: -6px;
  bottom: -17px;
}
:host ::ng-deep .noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}
:host ::ng-deep .noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
}
:host ::ng-deep .noUi-connects {
  border-radius: 3px;
}
:host ::ng-deep .noUi-connect {
  background: #3FB8AF;
}
:host ::ng-deep .noUi-draggable {
  cursor: ew-resize;
}
:host ::ng-deep .noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}
:host ::ng-deep .noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}
:host ::ng-deep .noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}
:host ::ng-deep .noUi-handle:before,
:host ::ng-deep .noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #E8E7E6;
  left: 14px;
  top: 6px;
}
:host ::ng-deep .noUi-handle:after {
  left: 17px;
}
:host ::ng-deep .noUi-vertical .noUi-handle:before,
:host ::ng-deep .noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}
:host ::ng-deep .noUi-vertical .noUi-handle:after {
  top: 17px;
}
:host ::ng-deep [disabled] .noUi-connect {
  background: #B8B8B8;
}
:host ::ng-deep [disabled].noUi-target,
:host ::ng-deep [disabled].noUi-handle,
:host ::ng-deep [disabled] .noUi-handle {
  cursor: not-allowed;
}
:host ::ng-deep .noUi-pips,
:host ::ng-deep .noUi-pips * {
  box-sizing: border-box;
}
:host ::ng-deep .noUi-pips {
  position: absolute;
  color: #999;
}
:host ::ng-deep .noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}
:host ::ng-deep .noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}
:host ::ng-deep .noUi-marker {
  position: absolute;
  background: #CCC;
}
:host ::ng-deep .noUi-marker-sub {
  background: #AAA;
}
:host ::ng-deep .noUi-marker-large {
  background: #AAA;
}
:host ::ng-deep .noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}
:host ::ng-deep .noUi-value-horizontal {
  transform: translate(-50%, 50%);
}
:host ::ng-deep .noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}
:host ::ng-deep .noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}
:host ::ng-deep .noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}
:host ::ng-deep .noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}
:host ::ng-deep .noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}
:host ::ng-deep .noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}
:host ::ng-deep .noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}
:host ::ng-deep .noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}
:host ::ng-deep .noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}
:host ::ng-deep .noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}
:host ::ng-deep .noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}
:host ::ng-deep .noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}
:host ::ng-deep .noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}
:host ::ng-deep .noUi-horizontal .noUi-origin > .noUi-tooltip {
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}
:host ::ng-deep .noUi-vertical .noUi-origin > .noUi-tooltip {
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}
:host ::ng-deep .noUi-connect {
  background-color: #ff9813;
}
:host ::ng-deep .noUi-horizontal .noUi-tooltip {
  transform: none;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  top: 0;
  padding: 1px;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/page/components/search-page/components/rating-filter/rating-points-range/rating-points-range.component.scss","webpack://./node_modules/nouislider/dist/nouislider.css"],"names":[],"mappings":"AAAA,2BAAA;ACIA;ECJA;;;IAAA;EA2BA;IAAA;EAqBA;IAAA;EAMA;;IAAA;EA2BA;IAAA;EAwBA;;IAAA;EAeA;IAAA;EAkBA;IAAA;EA0BA;IAAA;EAUA;;IAAA;EAYA;;IAAA;EAYA;;IAAA;EAaA;;IAAA;EA6BA;;IAAA;ADzMA;ACnCA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;ADqCF;ACnCA;EACE,kBAAA;ADqCF;ACnCA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ADqCF;ACjCA;EACE,gBAAA;EACA,UAAA;ADmCF;ACjCA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;ADmCF;AC/BA;EACE,OAAA;EACA,WAAA;ADiCF;AC5BA;EACE,UAAA;EACA,QAAA;AD8BF;AC5BA;EACE,SAAA;AD8BF;AC5BA;EAEE,2BAAA;EACA,kBAAA;AD8BF;AC5BA;EACE,YAAA;EACA,WAAA;AD8BF;AC5BA;;EAGE,0BAAA;AD8BF;AC5BA;EACE,0BAAA;AD8BF;AC1BA;EACE,YAAA;AD4BF;AC1BA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AD4BF;AC1BA;EACE,WAAA;AD4BF;AC1BA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AD4BF;AC1BA;EACE,WAAA;EACA,WAAA;AD4BF;ACvBA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wDAAA;ADyBF;ACvBA;EACE,kBAAA;ADyBF;ACvBA;EACE,mBAAA;ADyBF;ACrBA;EACE,iBAAA;ADuBF;ACrBA;EACE,iBAAA;ADuBF;ACrBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;ADuBF;ACrBA;EACE,yEAAA;ADuBF;ACnBA;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;ADqBF;ACnBA;EACE,UAAA;ADqBF;ACnBA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;ADqBF;ACnBA;EACE,SAAA;ADqBF;ACjBA;EACE,mBAAA;ADmBF;ACjBA;;;EAGE,mBAAA;ADmBF;ACdA;;EAGE,sBAAA;ADgBF;ACdA;EACE,kBAAA;EACA,WAAA;ADgBF;ACXA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;ADaF;ACXA;EACE,WAAA;EACA,eAAA;ADaF;ACRA;EACE,kBAAA;EACA,gBAAA;ADUF;ACRA;EACE,gBAAA;ADUF;ACRA;EACE,gBAAA;ADUF;ACLA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ADOF;ACLA;EAEE,+BAAA;ADOF;ACLA;EAEE,8BAAA;ADOF;ACLA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;ADOF;ACLA;EACE,YAAA;ADOF;ACLA;EACE,YAAA;ADOF;ACFA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;ADIF;ACFA;EAEE,6BAAA;EACA,kBAAA;ADIF;ACFA;EAEE,4BAAA;ADIF;ACFA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;ADIF;ACFA;EACE,WAAA;ADIF;ACFA;EACE,WAAA;ADIF;ACFA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ADIF;ACFA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;ADIF;ACFA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;ADIF;ACFA;EAEE,4BAAA;EACA,UAAA;EACA,YAAA;ADIF;ACFA;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;ADIF;AA1SE;EACE,yBAAA;AA4SJ;AAzSE;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;AA2SJ","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n\n:host ::ng-deep {\n\n  @import \"nouislider/dist/nouislider\";\n\n  .noUi-connect {\n    background-color: #ff9813;\n  }\n\n  .noUi-horizontal .noUi-tooltip {\n    transform: none;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 10;\n    top: 0;\n    padding: 1px;\n  }\n}\n","/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n/* Offset direction\n */\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n  left: 0;\n  right: auto;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  top: -100%;\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  right: -17px;\n  top: -6px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  right: -6px;\n  bottom: -17px;\n}\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n  left: -17px;\n  right: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n  border: 1px solid #D3D3D3;\n  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #E8E7E6;\n  left: 14px;\n  top: 6px;\n}\n.noUi-handle:after {\n  left: 17px;\n}\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n.noUi-horizontal .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(50%, 0);\n  transform: translate(50%, 0);\n  left: auto;\n  bottom: 10px;\n}\n.noUi-vertical .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(0, -18px);\n  transform: translate(0, -18px);\n  top: auto;\n  right: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
